<template>
	<div class="card">
		<div class="card-header">
			<router-link :to="{ name: 'instructions' }" class="float-left">
				<font-awesome-icon icon="angle-left" class="text-warning mr-2"/>
				<span class="text-white">Späť</span>
			</router-link>
			<span>{{ item.subject }}</span>
		</div>
		<div class="card-body py-4 px-5">
			<div v-if="item.options">
				<div class="row">
					<div class="details-wrapper col-12">
						<div class="row" v-if="item.options">
							<div v-if="item.options.instruction_id" class="col-12">
								<h6>Vážený klient,</h6>
								<br/>
								<span>
									v prílohe Vám zasielame detail pokynu {{ item.options.instruction_idno }}.
								</span>
							</div>

							<div v-else-if="item.options.transactionType || item.options.toConfirmTrade || item.options.toConfirmWithdrawal" class="col-12">
								<h6>Vážený klient,</h6>
								<br/>
								<span v-if="item.options.toConfirmWithdrawal === true">
									bol vytvorený pokyn na {{ item.options.transactionType === "withdrawal" ? "výber" : "vklad" }} peňažných prostriedkov. Pokyn je možné zaevidovať a zrealizovať.
								</span>
								<span v-else-if="item.options.toConfirmTrade === true">
									bol vytvorený pokyn na {{ item.options.transactionType === "buy" ? "nákup" : "predaj" }} cenných papierov. Pokyn je možné zaevidovať a zrealizovať.
								</span>
								<span v-else>
									pokyn na {{ item.options.transactionType === "withdrawal" ? "výber" : "vklad" }} peňažných prostriedkov bol úspešne zaevidovaný.
								</span>
								<br/>
								<table class="my-4">
									<tr>
										<td class="pr-4"><b>Investičná stratégia:</b></td>
										<td>{{ item.options.strategyName }}</td>
									</tr>
									<tr v-if="item.options.date">
										<td><b>Platnosť pokynu:</b></td>
										<td>{{ item.options.date | date }}</td>
									</tr>
									<tr>
										<td><b>Suma:</b></td>
										<td>{{ item.options.value }}</td>
									</tr>
								</table>

								<template v-if="item.options.toConfirmTrade || item.options.toConfirmWithdrawal">
									<template v-if="item.options.accepted">
										<span class="sfa-status sfa-status-success" v-if="isSfa">
											Odoslaný pokyn
										</span>
									</template>
									<template v-else>
										<span class="sfa-status sfa-status-warning" v-if="isSfa">
											Čaká na schválanie
										</span>
										<button v-else @click="createInstructionSfa()" class="btn btn-warning">
		<!--									<font-awesome-icon icon="file-pdf" class="mr-2"/>-->
											Zrealizovať pokyn
										</button>
									</template>
									
								</template>
							</div>
						</div>
					</div>
				</div>

				<div
						class="mt-4 mb-3 pt-3 text-center"
						v-if="item.options.instruction_id"
				>
					<button @click="downloadInstruction" class="btn btn-warning">
						<font-awesome-icon
								v-if="loading"
								icon="spinner"
								class="mx-2"
								spin
						/>
						<font-awesome-icon v-else icon="file-pdf" class="mr-2"/>
						Stiahnuť detail pokynu
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "InstructionDetail",
	created() {
		// eslint-disable-next-line @typescript-eslint/no-this-alias
		const _that = this;

		this.$store.dispatch("messages/messageDetail", {
			id: this.$route.params.id
		});
	},
	data() {
		return {
			loading: false,
			instructionToCreate: {},
		};
	},
	computed: {
		item() {
			return this.$store.state.messages.item;
		},
		assignedToMe() {
			return this.$store.state.account.assignedToMe;
		},
		isSfa() {
			if (this.assignedToMe.length > 0) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		downloadInstruction() {
			this.loading = true;
			this.$store
					.dispatch("messages/downloadInstruction", this.item.options)
					.then(() => {
						this.loading = false;
					});
		},
		createInstructionSfa() {
			this.$store.dispatch("messages/messageDetail", {
				id: this.$route.params.id
			}).then((res) => {
				const options = res.options;
				const sfaRequest = this.$root.$children[0].$children[1].$children[1];

				this.$store.commit('instructions/setSfaInstruction', options);

				if(options.toConfirmWithdrawal === true) {
					sfaRequest.showModal('withdrawal');
				} else {
					sfaRequest.showModal('trade');
				}
			});
		},
	}
};
</script>

<style lang="scss">
.pre-wrap {
	white-space: pre-wrap;
}


.sfa-status {
	padding: 8px 12px;
	border: 3px solid $success;

	&-success {
		border-color: $success;
	}

	&-warning {
		border-color: darken($warning, 10%);
	}
}
</style>
